import { css } from 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import { tint } from 'polished';
import _defaultPalette from '../default/palette.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import Label from 'reakit/Label';
import 'reakit/Input';
import { a as HiddenInput } from '../chunk-2cd0d082.js';

var defaultPalette = _defaultPalette({});

var SwitchIcon = styled(Box).withConfig({
  displayName: "styled__SwitchIcon",
  componentId: "ohpvlq-0"
})(["background-color:", ";border:1px solid #bdbdbd;border-radius:1em;height:1.5em;position:relative;width:3em;&{", ";}&{", ";}"], palette('white700'), function (props) {
  return props.state && css(["border-color:", ";box-shadow:", " 0px 0px 0px 1px !important;"], function (props) {
    return palette("" + props.state);
  }, function (props) {
    return palette("" + props.state);
  });
}, theme('fannypack.Switch.base'));
var HiddenSwitch = HiddenInput({
  Icon: SwitchIcon,
  checkedCss: css(["background-color:", ";transition:all ease 0.2s;"], function (props) {
    return palette(props.palette || 'primary');
  }),
  disabledCheckedCss: css(["background-color:", ";border-color:", ";"], function (props) {
    return tint(0.5, palette(props.palette || 'primary', 0, defaultPalette.primary)(props));
  }, function (props) {
    return tint(0.5, palette(props.palette || 'primary', 0, defaultPalette.primary)(props));
  }),
  disabledUncheckedIconCss: css(["background:", ";"], palette('white700')),
  checkedIconCss: css(["border-color:", ";left:1.7em;"], function (props) {
    return palette(props.palette || 'primary', 0, defaultPalette.primary);
  }),
  disabledCheckedIconCss: css(["border-color:", ";"], function (props) {
    return tint(0.5, palette(props.palette || 'primary', 0, defaultPalette.primary)(props));
  }),
  uncheckedIconCss: css(["background:white;content:'';border-radius:100%;border:1px solid #bdbdbd;height:1em;width:1em;top:0.2em;left:0.2em;transition:all ease 0.2s;position:absolute;"]),
  themePrefix: 'Switch'
});
var Switch = styled(Label).withConfig({
  displayName: "styled__Switch",
  componentId: "ohpvlq-1"
})(["align-items:center;cursor:", ";display:flex;&{", ";}"], function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, theme('fannypack.Switch.label'));

export default Switch;
export { HiddenSwitch, Switch, SwitchIcon };
